import React from "react";
import { customWebDesign, tech, Custom, Advantages, three, two, one } from "../../Assets.tsx";
import { ServiceShell, Section, Hero, Intro, Split, FeatureGrid, CheckList, Cta } from "../Common-component/ServiceKit";

const necessity = [
  {
    img: one,
    alt: "Stand out",
    title: "Stand Out",
    text: "A custom web solution can help you stand out and gain an advantage over your competitors, but whether it is necessary for your operation depends on the type of your business and the website you want to design.",
  },
  {
    img: two,
    alt: "User experience",
    title: "User Experience",
    text: "To be clear, consider web design the user experience components of website development (the web visuals, user interface design, and other aesthetic components).",
  },
  {
    img: three,
    alt: "Front-end and back-end",
    title: "Front-End & Back-End",
    text: "Both the front-end and back-end of a website must be coded. The work done in the background makes it possible for a website to function quickly, look exactly as intended, and look good across all devices and browsers.",
  },
  {
    img: tech,
    alt: "Security",
    title: "Security",
    text: "The security of a website is maintained with the help of custom web development.",
  },
];

const advantages = [
  "At first, your website will have a distinctive look representing your business.",
  "Given the prevalence of pre-made themes today, you have undoubtedly come across websites with striking similarities in appearance and functionality.",
  "This is due to identical templates, with (often) only the text and visuals changed.",
  "Your capacity to stand out in a sea of copy-and-paste solutions is considerably improved by being original.",
  "With a unique website that customers haven't seen, you'll capture their interest immediately and come off as a lot more credible and experienced.",
  "With custom solutions, you have more area for distinctive corporate branding, which is crucial for making your company a reputable and trusted leader in your sector.",
  "Finally, you have total control over every component of the bespoke web development solution.",
];

const WebDesignPage = () => (
  <ServiceShell>
    {/* HERO */}
    <Hero
      chip="Web Design"
      title="Custom Website Design"
      sub="Easy, Convenient Online Website Builder For Everyone."
      paragraphs={[
        "Custom web design encompasses more than your website’s colour scheme, graphics, and fonts. A custom web design is learning about your company, applying a good strategy, user experience, design execution, programming, and marketing to create an effective online business presence. Your website was specifically designed with your organizational objectives in mind. This service is crucial for developing a productive digital asset with a good ROI.",
        "Here at ATUM Information Technology, we have a wide variety of certified partners and a customer-centric team to manage your projects end-to-end. And our main motto is your vision, which is our efficiency.",
      ]}
      tags={["Strategy", "User Experience", "Design", "Programming"]}
      img={customWebDesign}
      alt="Custom website design"
    />

    {/* WHAT IS IT */}
    <Section tint>
      <Split
        img={Custom}
        alt="Custom web development"
        chip="Custom Development"
        title="Custom Web Development Solution Is What?"
        sub="Use website elements to establish and represent your brand."
        paragraphs={[
          "Custom web development refers to a customized website solution for your brand, business goal, product, or service. It enables you to design a unique website. In addition to the website’s obvious design, a unique website offers a variety of capabilities that were created to be as efficient as possible in assisting your business goals rather than hindering them.",
        ]}
      />
    </Section>

    {/* WHY NECESSARY */}
    <Section>
      <Intro chip="Why It Matters" title="Why Is A Custom Web Development Solution Necessary?">
        <FeatureGrid items={necessity} cols={4} />
      </Intro>
    </Section>

    {/* ADVANTAGES */}
    <Section tint>
      <Split
        img={Advantages}
        alt="Advantages of specialized development"
        reverse
        chip="Advantages"
        title="Advantages Of Specialized Development Services Provided By Our Developers"
      >
        <CheckList items={advantages} />
      </Split>
    </Section>

    {/* WHY US */}
    <Cta
      chip="Why Us"
      title="Why Choose Us?"
      paragraphs={[
        "Website design services at ATUM Information Technology are provided until the client is completely happy, followed by any required customer support. Additionally, we provide quick customer support and create your website using the most recent techniques. We recognize that your website acts as a reflection of your company, so we give you one that not only looks amazing but also has all the newest features.",
      ]}
    />
  </ServiceShell>
);

export default WebDesignPage;